import React, { Component } from "react";
import { Helmet } from 'react-helmet-async';

export class MetaHelmet extends Component {
    static displayName = MetaHelmet.name;

    constructor(props) {
        super(props);

        this.defaultSiteName = "Sielaff Bohemia";
        this.defaultSiteNameWithSuffix = `${this.defaultSiteName} s.r.o.`;
        this.defaultImage = "sielaff_bohemia_logo.png";
        this.defaultOgType = "website";
    }

    GetLangTerritory(code, separator = '_') {

        if (typeof code != 'string')
            code = '';

        code = code.toLowerCase()

        switch (code) {
            case "en":
                return `en${separator}US`;
            case "de":
                return `de${separator}DE`;
            case 'cs':
            default:
                return `cs${separator}CZ`;
        }
    }

    GetHelmet(tags) {
        tags = new TagModel(tags);

        // Set default values if not provided
        tags.title = tags.title === null ? this.defaultSiteNameWithSuffix : `${tags.title}`;
        tags.ogImage = `${window.location.origin}/files/images/${this.defaultImage}`;
        tags.ogType = tags.ogType ?? this.defaultOgType;

        // Set ogUrl based on window location
        if (tags.ogUrl) {
            tags.ogUrl = `${window.location.origin}/${tags.ogUrl}`;
        } else {
            tags.ogUrl = `${window.location.origin}${window.location.pathname}`;
        }

        if (tags.canonicalLink)
            tags.canonicalLink = `${window.location.origin}/${tags.canonicalLink}`;

        // Additional tags configuration
        tags.ogTitle = tags.ogTitle ?? tags.title;
        tags.ogDescription = tags.ogDescription ?? tags.description;

        if (tags.allLocales.length > 0) {
            tags.ogLocaleAlternate = tags.allLocales.filter(l => l.code !== tags.locale);

            // Hreflangs pouze pro platné (aktivní) jazyky
            if (tags.alternateHreflangs.length > 0) {
                tags.alternateHreflangs = tags.alternateHreflangs
                    .filter(h => h.language != tags.locale)
                    .map(h => ({
                        language: h.language,
                        url: `${window.location.origin}/${h.language}/${h.url}`
                    }));
            }       

            //console.log(tags);

        } else {
            tags.ogLocaleAlternate = [];
            tags.alternateHreflangs = [];
        }

        return (
            <Helmet>
                {/* Title of the page */}
                <title>{tags.title}</title>
                <meta name="title" content={tags.title} />

                <meta http-equiv="content-language" content={this.GetLangTerritory(tags.locale, '-')} />

                {/* Meta description for the page */}
                {tags.description && <meta name="description" content={tags.description} />}

                {/* Canonical link of the page */}
                {tags.canonicalLink && <link rel="canonical" href={tags.canonicalLink} />}

                {/* Open Graph title */}
                <meta property="og:title" content={tags.ogTitle} />

                {/* Open Graph description */}
                {tags.ogDescription && <meta property="og:description" content={tags.ogDescription} />}

                {/* Open Graph type */}
                <meta property="og:type" content={tags.ogType} />

                {/* Open Graph image */}
                <meta property="og:image" content={tags.ogImage} />

                {/* Open Graph URL */}
                {tags.ogUrl && <meta property="og:url" content={tags.ogUrl} />}

                {/* Open Graph alternate locales */}
                {tags.ogLocaleAlternate.map(l => (
                    <meta key={l.code} property="og:locale:alternate" content={this.GetLangTerritory(l.code)} />
                ))}

                {/* Open Graph alternate locales */}
                {tags.alternateHreflangs.map(h => (
                    <link key={h.language} rel="alternate" hreflang={this.GetLangTerritory(h.language)} href={h.url} />
                ))}

                {/* Primary locale for the page */}
                {tags.locale && <meta property="og:locale" content={this.GetLangTerritory(tags.locale)} />}
                {tags.locale && (document.documentElement.lang = tags.locale) }

            </Helmet>
        );
    }

    render() {
        return (
            this.GetHelmet(this.props.tags)
        );
    }
}

class TagModel {
    /**
     * @param {string} title - Title of the page.
     * @param {string} description - Meta description for the page.
     * @param {string} canonicalLink - Canonical link of the page.
     * @param {string} ogTitle - Open Graph title.
     * @param {string} ogDescription - Open Graph description.
     * @param {string} ogImage - Open Graph image URL.
     * @param {string} ogUrl - Open Graph URL.
     * @param {string} ogType - Open Graph type (e.g., "website").
     * @param {string} locale - Primary locale for the page (e.g., "en", "de", "cs").
     * @param {string} allLocales - All active locales (e.g., "en", "de", "cs").
     * @param {Array<string>} alternateHreflangs - Array of alternate locale urls 
     */
    constructor({
        title = null,
        description = null,
        canonicalLink = null,
        ogTitle = null,
        ogDescription = null,
        ogImage = null,
        ogUrl = null,
        ogType = null,
        locale = null,
        //ogLocaleAlternate = [],
        allLocales = [],
        alternateHreflangs = []
    } = {}) {
        this.title = title;
        this.description = description;
        this.canonicalLink = canonicalLink;
        this.ogTitle = ogTitle;
        this.ogDescription = ogDescription;
        this.ogImage = ogImage;
        this.ogUrl = ogUrl;
        this.ogType = ogType;
        this.locale = locale;
        this.ogLocaleAlternate = [];
        this.allLocales = allLocales;
        this.alternateHreflangs = alternateHreflangs;
    }
}